import { render } from "./HiveImage.vue?vue&type=template&id=0de19574"
import script from "./HiveImage.vue?vue&type=script&lang=js"
export * from "./HiveImage.vue?vue&type=script&lang=js"
script.render = render

export default script